/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'element-video': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M42 8H5v32h37V8zM5 5a3 3 0 0 0-3 3v32a3 3 0 0 0 3 3h37a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H5z"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M20.5 18.9v11.2l7.905-5.6-7.905-5.6zm-3-.966c0-2.03 2.29-3.213 3.945-2.04l9.27 6.566a2.5 2.5 0 0 1 0 4.08l-9.27 6.566c-1.656 1.173-3.945-.01-3.945-2.04V17.934z"/>'
  }
})
